import { once } from "@utils/general";

import {
    CALCULATOR_KEYS,
    CalculatorConfig,
    getCalculatorConfig,
} from "@services/tracking/trackers/tools/calculators/config";
import { trackCalculatorToolStep } from "@services/tracking/trackers/tools/calculators/tracker";
import { EventTypes } from "@services/tracking/types/eventTypes";

const trackCalculatorStepStarted = once((calculatorKey: CALCULATOR_KEYS) => {
    if (!calculatorKey) return;

    const config: CalculatorConfig = getCalculatorConfig(calculatorKey);

    trackCalculatorToolStep(EventTypes.ToolStep, config.start, config.context);
});

const trackCalculatorStepSubmitted = once((calculatorKey: CALCULATOR_KEYS) => {
    if (!calculatorKey) return;

    const config: CalculatorConfig = getCalculatorConfig(calculatorKey);

    trackCalculatorToolStep(
        EventTypes.ToolStepSubmit,
        config.submit,
        config.context,
    );
});

export { trackCalculatorStepSubmitted, trackCalculatorStepStarted };
